
import { useEffect, useRef, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { api } from "../../../utils/api";
import { LoginHelper } from "../../../utils/LoginHelper";
import Button from "../../common/button/Button";
import { authSectionCard, AuthCardTopAccent } from "../common/authCard";
import AuthSubmitBar from "../common/AuthSubmitBar";
import FieldDigit from "./FieldDigit";
import Timer from "./Timer";

export default function Form({ phoneNumber }) {
	const navigate = useNavigate();
	const [digit1, setDigit1] = useState("");
	const [digit2, setDigit2] = useState("");
	const [digit3, setDigit3] = useState("");
	const [digit4, setDigit4] = useState("");
	const digit1Ref = useRef(null);
	const digit2Ref = useRef(null);
	const digit3Ref = useRef(null);
	const digit4Ref = useRef(null);
	const [isLoading, setIsLoading] = useState(false);
	const [errorMessage, setErrorMessage] = useState("");

	useEffect(() => {
		sendIfFilledCode();
	}, [digit4]);

	useEffect(() => {
		window.digit1Ref = digit1Ref;
		window.digit2Ref = digit2Ref;
		window.digit3Ref = digit3Ref;
		window.digit4Ref = digit4Ref;
	}, []);

	function verifyCode() {
		if (isLoading) return;
		const code = digit1 + digit2 + digit3 + digit4;
		setIsLoading(true);
		setErrorMessage("");
		api.profileVerify({
			phone_number: phoneNumber,
			verification_code: code,
		})
			.then((result) => {
				setIsLoading(false);
				LoginHelper.login(result.token, result.profile_id, result.profile_mode);
				navigate("/");
			})
			.catch((err) => {
				setIsLoading(false);
				if (err && err.data) {
					setErrorMessage(err.data.message);
				}
			});
	}

	function sendIfFilledCode() {
		if (digit1 && digit2 && digit3 && digit4) {
			verifyCode();
		}
	}

	const handleDigitFill = (index, digit) => {
		if (index === 1) {
			setDigit1(digit);
			digit2Ref.current.focus();
		} else if (index === 2) {
			setDigit2(digit);
			digit3Ref.current.focus();
		} else if (index === 3) {
			setDigit3(digit);
			digit4Ref.current.focus();
		} else if (index === 4) {
			setDigit4(digit);
		}
	};

	const handleDigitClear = (index) => {
		if (index === 1) {
			setDigit1("");
		} else if (index === 2) {
			setDigit2("");
			digit1Ref.current.focus();
		} else if (index === 3) {
			setDigit3("");
			digit2Ref.current.focus();
		} else if (index === 4) {
			setDigit4("");
			digit3Ref.current.focus();
		}
	};

	const displayPhone = phoneNumber || "—";

	return (
		<div className={[authSectionCard, "w-full flex flex-col gap-4"].join(" ")}>
			<AuthCardTopAccent />
			<p className="font-Vazir-400 text-[14px] text-midGray text-center leading-6 pt-1">
				کد ارسال‌شده به{" "}
				<span className="font-Vazir-600 text-midGray" dir="ltr">
					{displayPhone}
				</span>{" "}
				را وارد کنید.
			</p>
			<Link
				to="/login/"
				className="text-center font-Vazir-600 text-[13px] text-cta hover:underline"
			>
				ویرایش شماره همراه
			</Link>
			<div className="flex flex-row-reverse justify-center gap-2 sm:gap-3 py-1">
				<FieldDigit ref={digit1Ref} index={1} onFill={handleDigitFill} onClear={handleDigitClear} />
				<FieldDigit ref={digit2Ref} index={2} onFill={handleDigitFill} onClear={handleDigitClear} />
				<FieldDigit ref={digit3Ref} index={3} onFill={handleDigitFill} onClear={handleDigitClear} />
				<FieldDigit ref={digit4Ref} index={4} onFill={handleDigitFill} onClear={handleDigitClear} />
			</div>
			<Timer phoneNumber={phoneNumber} />
			{errorMessage ? (
				<p className="text-center font-Vazir-400 text-[14px] text-error">{errorMessage}</p>
			) : null}
			<AuthSubmitBar>
				<Button
					onClick={() => {
						verifyCode();
					}}
					label="ورود"
					isLoading={isLoading}
					className="h-full rounded-none rounded-b-xl"
					labelClassName="font-Vazir-700 text-[16px]"
				/>
			</AuthSubmitBar>
		</div>
	);
}
